export function extendValidateMessage(locate) {
    locate.messages.required = function (n) { return "必填项信息不可为空"; };
    locate.messages.confirmed = function (n, e) { return " " + n + " 和" + e[0] + "输入不一致，请重新输入！"; };
}
